import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/core/helpers/auth.service';
import { CoreService } from 'src/app/core/helpers/core.service';
import { GaService } from 'src/app/core/helpers/ga.service';
import { NavigationEnd, Router } from '@angular/router';


@Component({
  selector: 'loyaltic-rewards-list',
  templateUrl: './rewards-list.component.html',
  styleUrls: ['./rewards-list.component.scss']
})
export class RewardsListComponent implements OnInit {
  userId = '';
  userType = '';
  rewards = [];
  results ;
  culture = '';
  isLoggedIn = false;
  currentPage = '';
  orderSize: any[] = [];
  defaultRewardImageUrl = 'https://res.cloudinary.com/lojaali/image/upload/q_auto/v1641884290/SWEPEPSIMAX24/default.jpg';


  @ViewChild('captureAddress', { static: false }) captureAddressPopUpRef: any;
  @ViewChild('rewardDetailsModal', { static: false }) rewardDetailsModalRef: any;
  @ViewChild('rewardDetailImageBlock', { static: false }) rewardDetailImageBlockRef: ElementRef;
  @ViewChild('rewardDetailImage', { static: false }) rewardDetailImageRef: ElementRef;
  public modalRef: BsModalRef;
  popupConfig = {
    ignoreBackdropClick: true,
    class: 'modal-lg modal-order modal-dialog-centered',
  };

  rewardDetails: any;
  selectedReward: any;
  selectedRewardDetailImageUrl = '';
  rewardImageZoom = 1;
  rewardImagePanX = 0;
  rewardImagePanY = 0;
  rewardImageSizePercent = 100;
  rewardImageTransform = 'translate3d(0px, 0px, 0)';
  isRewardImagePanning = false;
  private readonly rewardImageMinZoom = 1;
  private readonly rewardImageMaxZoom = 3;
  private readonly rewardImageZoomStep = 0.25;
  private rewardImagePanStartX = 0;
  private rewardImagePanStartY = 0;
  private rewardImagePanOriginX = 0;
  private rewardImagePanOriginY = 0;

  constructor(private coreService: CoreService, private authService: AuthService,
    private modalService: BsModalService, private translate: TranslateService, private toast: ToastrService,
    private router: Router, private gaService: GaService) {
    this.userId = authService.getUserId();
    this.userType = authService.getUserType();
    this.culture = translate.getDefaultLang();
    this.isLoggedIn = authService.IsLoggedIn()
  }

  ngOnInit() {
    this.getRewards();
    this.currentPage = this.router.url;
    //console.log(this.currentPage);
  }

  getRewards() {
    this.coreService.getRewards(this.culture, this.userId).then((response: any) => {
      this.results = response.result;
      this.rewards = response.result.rewards;
      this.orderSize = response.result.rewardSizes;
      // console.log(this.rewards);
      this.gaService.emitEvent('Rewards_Ordered', this.userType);
    });
  }

  onRedeemClick(reward) {
    this.rewardDetails = reward;
    this.modalRef = this.modalService.show(this.captureAddressPopUpRef, this.popupConfig);
  }

  openRewardDetails(reward) {
    this.selectedReward = reward;
    this.selectedRewardDetailImageUrl = reward && reward.mainImageUrl;
    this.resetRewardImageZoom();
    this.modalRef = this.modalService.show(this.rewardDetailsModalRef, {
      class: 'modal-lg modal-dialog-centered modal-order'
    });
  }

  zoomRewardImageIn() {
    this.rewardImageZoom = Math.min(
      this.rewardImageMaxZoom,
      this.rewardImageZoom + this.rewardImageZoomStep
    );
    this.updateRewardImageSize();
    this.clampRewardImagePanAfterResize();
  }

  zoomRewardImageOut() {
    this.rewardImageZoom = Math.max(
      this.rewardImageMinZoom,
      this.rewardImageZoom - this.rewardImageZoomStep
    );

    this.updateRewardImageSize();

    if (this.rewardImageZoom === this.rewardImageMinZoom) {
      this.resetRewardImagePan();
      return;
    }

    this.clampRewardImagePanAfterResize();
  }

  resetRewardImageZoom() {
    this.rewardImageZoom = this.rewardImageMinZoom;
    this.updateRewardImageSize();
    this.resetRewardImagePan();
  }

  startRewardImagePan(event: any) {
    if (this.rewardImageZoom <= this.rewardImageMinZoom) {
      return;
    }

    if (typeof event.button === 'number' && event.button !== 0) {
      return;
    }

    const point = this.getRewardImagePanPoint(event);

    if (!point) {
      return;
    }

    event.preventDefault();
    this.isRewardImagePanning = true;
    this.rewardImagePanStartX = point.x;
    this.rewardImagePanStartY = point.y;
    this.rewardImagePanOriginX = this.rewardImagePanX;
    this.rewardImagePanOriginY = this.rewardImagePanY;
  }

  moveRewardImagePan(event: any) {
    if (!this.isRewardImagePanning) {
      return;
    }

    const point = this.getRewardImagePanPoint(event);

    if (!point) {
      return;
    }

    event.preventDefault();
    this.rewardImagePanX = this.rewardImagePanOriginX + point.x - this.rewardImagePanStartX;
    this.rewardImagePanY = this.rewardImagePanOriginY + point.y - this.rewardImagePanStartY;
    this.clampRewardImagePan();
    this.updateRewardImageTransform();
  }

  stopRewardImagePan() {
    this.isRewardImagePanning = false;
  }

  private resetRewardImagePan() {
    this.rewardImagePanX = 0;
    this.rewardImagePanY = 0;
    this.isRewardImagePanning = false;
    this.updateRewardImageTransform();
  }

  private getRewardImagePanPoint(event: any): { x: number, y: number } | null {
    const touch = event.touches && event.touches.length ? event.touches[0] : null;
    const changedTouch = event.changedTouches && event.changedTouches.length ? event.changedTouches[0] : null;
    const point = touch || changedTouch || event;

    if (typeof point.clientX !== 'number' || typeof point.clientY !== 'number') {
      return null;
    }

    return {
      x: point.clientX,
      y: point.clientY
    };
  }

  clampRewardImagePan() {
    const blockElement = this.rewardDetailImageBlockRef && this.rewardDetailImageBlockRef.nativeElement;
    const imageElement = this.rewardDetailImageRef && this.rewardDetailImageRef.nativeElement;

    if (!blockElement || !imageElement) {
      return;
    }

    const maxPanX = Math.max(0, (imageElement.clientWidth - blockElement.clientWidth) / 2);
    const maxPanY = Math.max(0, (imageElement.clientHeight - blockElement.clientHeight) / 2);

    this.rewardImagePanX = Math.max(-maxPanX, Math.min(maxPanX, this.rewardImagePanX));
    this.rewardImagePanY = Math.max(-maxPanY, Math.min(maxPanY, this.rewardImagePanY));
    this.updateRewardImageTransform();
  }

  private updateRewardImageSize() {
    this.rewardImageSizePercent = this.rewardImageZoom * 100;
  }

  private updateRewardImageTransform() {
    this.rewardImageTransform = `translate3d(${this.rewardImagePanX}px, ${this.rewardImagePanY}px, 0)`;
  }

  private clampRewardImagePanAfterResize() {
    setTimeout(() => this.clampRewardImagePan());
  }

  NotifyuserClick(RewardPartitionkey) {
    this.coreService.Notifyuser(this.userId, RewardPartitionkey)
      .then((response: any) => {
        const messageKey = response.messageKey;
        this.toast.success(this.translate.instant('' + messageKey), '');
        this.getRewards();
      });
  }


  onHideCaptureDetails() {
    this.modalRef.hide();
  }

}
